<template>
    <v-container>
        <div v-if="!loading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Landed Cost Component</h4>
                    <p class="text-subtitle-1">Landed cost component information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.landed_cost_component.update)">
                    <v-btn depressed block @click="onEdit">
                        <v-icon left>mdi-pencil</v-icon>
                        edit information
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(permissions.landed_cost_component.delete)">
                    <v-btn depressed block color="error--text" @click="onRemove" :loading="removeLoading">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <td>{{ data.name }}</td>
                            </tr>
                            <tr>
                                <th>G/L Account</th>
                                <td>
                                    <span v-if="data && data.ledger_account">
                                        {{ data.ledger_account.name }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </v-container>
</template>

<script>
import PAlert from '../../components/common/PAlert.vue';
import landedCostComponent from '../../services/purchase/landedCostComponent';
import permissions from '../../data/permissions';
import authorize from '../../utils/authorize';
export default {
    components: {
        PAlert
    },
    data() {
        return {
            id: null,
            data: {},
            alert: {
                display: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            removeLoading: false,
            loading: false,
            permissions
        }
    },
    methods: {
        hasPermission(code) {
            return authorize(code);
        },
        onRemove() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to delete?", callback: this.remove };
        },
        remove() {
            this.removeLoading = true;
            landedCostComponent.remove(this.id).then(() => {
                this.$router.push({
                    name: "LandedCostComponentList"
                })
            }).finally(() => {
                this.removeLoading = false;
            })
        },
        fetch() {
            this.loading = true;
            landedCostComponent.find(this.id).then(res => {
                this.data = res.data;
            }).finally(() => {
                this.loading = false;
            })
        },
        onEdit() {
            this.$router.push({
                name: "LandedCostComponentEdit",
                params: {
                    id: this.id
                }
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }
}
</script>

<style>

</style>